/*
 * ez-discount-banner — copy-to-clipboard for the optional offer code.
 * One vanilla custom element, defined once (theme-foundation.md §A5). Copies the code, then
 * shows a calm ✓ confirmation for ~2s (success is calm, not celebratory — design_system.md §4.1).
 */
(function () {
  if (customElements.get('ez-discount-banner')) return;

  class EzDiscountBanner extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-copy-button]');
      if (!this.btn) return;
      this.labelEl = this.btn.querySelector('.ez-offer__copy-label') || this.btn;
      this._origLabel = this.labelEl.textContent;
      this.btn.addEventListener('click', this._copy.bind(this));
    }

    _copy() {
      var code = this.btn.getAttribute('data-code') || '';
      var done = this._flash.bind(this);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () { done(); });
      } else {
        try {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.setAttribute('readonly', '');
          ta.style.position = 'absolute';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        } catch (e) { /* no-op */ }
        done();
      }
    }

    _flash() {
      if (this._timer) window.clearTimeout(this._timer);
      this.labelEl.textContent = '✓';
      this.btn.classList.add('is-copied');
      this.btn.setAttribute('aria-live', 'polite');
      this._timer = window.setTimeout(function () {
        this.labelEl.textContent = this._origLabel;
        this.btn.classList.remove('is-copied');
      }.bind(this), 2000);
    }
  }

  customElements.define('ez-discount-banner', EzDiscountBanner);
})();
